module.exports = __webpack_public_path__ + "static/media/product-guide-2020.e8e406d3.pdf";